import React from "react"
import GagImage from "../GagImage/GagImage";
import GagVideo from "../GagVideo/GagVideo";
import PropTypes from "prop-types"
import './GagPost.css';
import GagCategory from "../GagCategory/GagCategory";

export default class GagPost extends React.Component {

    constructor(props) {
        super(props)
        const {gag, darkTheme} = this.props

        this.state = {
            gag: gag,
            mediaHeight: null,
            mediaWidth: null,
            darkTheme: darkTheme
        }

        this.setMediaSize = this.setMediaSize.bind(this)

        this.randomColor = this.getRandomColor()
        let colorRatio
        if (this.state.darkTheme) {
            colorRatio = 10
        } else {
            colorRatio = 90
        }

        this.backgroundColor = "hsla(" + this.randomColor + ", 40%," + colorRatio + "%, 1)"

        let backgroundImage = ''
        if (gag.categoryPosts.length > 0) {
            backgroundImage = gag.categoryPosts[Math.round(Math.random() * (gag.categoryPosts.length - 1))]
            backgroundImage = `url("/cat-backgrounds/` + backgroundImage.category.backgroundImage + `")`
        }

        this.styles = {
            body: {
                backgroundColor: this.backgroundColor,
                backgroundImage: backgroundImage,
                backgroundSize: 'cover',
                backgroundBlendMode: (this.state.darkTheme ? 'multiply' : 'screen')
            }
        }

        for (let i in this.styles.body) {
            document.body.style[i] = this.styles.body[i];
        }
    }

    getRandomColor() {
        return Math.floor(360 * Math.random())
    }

    setMediaSize(media) {
        this.setState({
            mediaHeight: media.target.offsetHeight,
            mediaWidth: media.target.offsetWidth
        })
    }

    getWindowDimensions() {
        const {innerWidth: width, innerHeight: height} = window;
        return {
            width,
            height
        };
    }

    render() {

        let media = null
        if (this.state.gag.type === 'image') {
            media = <GagImage gag={this.state.gag} handleMediaLoad={this.setMediaSize} color={this.randomColor}/>
        } else if (this.state.gag.type === 'video') {
            media = <GagVideo gag={this.state.gag} handleMediaLoad={this.setMediaSize} color={this.randomColor}/>
        } else {
            media = "Unhandled gag type : " + this.state.gag.type
        }

        let categories = null
        let positionTop = 0

        if (this.state.mediaHeight !== null && this.state.mediaWidth !== null) {
            const mediaSize = {
                mediaHeight: this.state.mediaHeight,
                mediaWidth: this.state.mediaWidth,
            }

            const titleTotalHeight = 63
            const windowDimensions = this.getWindowDimensions()
            positionTop = (windowDimensions.height - (this.state.mediaHeight + titleTotalHeight)) / 3
            positionTop = (positionTop < 0 ? 0 : positionTop) + "px"


            let categorySequenceNumber = 0
            const categoryTotalNumber = this.state.gag.categoryPosts.length
            categories = this.state.gag.categoryPosts.map(
                category => {
                    categorySequenceNumber++
                    return <GagCategory key={this.state.gag.id + '-' + category.category.id} category={category}
                                        categorySequenceNumber={categorySequenceNumber} mediaSize={mediaSize}
                                        categoryTotalNumber={categoryTotalNumber} color={this.randomColor}/>
                }
            )
        }

        let title = <h3> </h3>
        if (this.state.gag.isDisplayedTitle) {
            title = <h3>{this.state.gag.title}</h3>
        }

        return <>
            {categories}
            <div
                className={(this.state.darkTheme ? "post-darkTheme" : "post-lightTheme") + " post "}
                id={this.state.gag.id}
                style={{
                    top: positionTop
                }}
            >
                {title}
                {media}
            </div>
        </>
    }
}

GagPost.propTypes = {
    gag: PropTypes.object.isRequired,
}